import { useEffect, useRef } from "react";

export function useScrollIntoView(scroll = false) {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    scroll && ref.current?.scrollIntoView({ block: "nearest" });
  }, [scroll]);

  return { ref };
}
